import { apiFetch, ApiError } from './client';

interface GeoCountryResponse {
  country_code: string;
}

// fetchCountryFromIP asks the API for the caller's country, derived server-side
// from the Cloudflare CF-IPCountry header. Returns null when the server has no
// confident answer (204) or any error — callers should treat the result as a
// best-effort suggestion, not a hard requirement.
export async function fetchCountryFromIP(token: string | null): Promise<string | null> {
  try {
    const res = await apiFetch<GeoCountryResponse | undefined>('/api/v1/geo/country', { token });
    return res?.country_code ?? null;
  } catch (err) {
    if (err instanceof ApiError) return null;
    throw err;
  }
}
